const integerFormat = new Intl.NumberFormat('id-ID', { maximumFractionDigits: 0 });
const compactFormat = new Intl.NumberFormat('id-ID', { maximumFractionDigits: 1 });

const COMPACT_UNITS: readonly { readonly size: number; readonly suffix: string }[] = [
  { size: 1_000_000_000_000, suffix: 'T' },
  { size: 1_000_000_000, suffix: 'M' },
  { size: 1_000_000, suffix: 'jt' },
  { size: 1_000, suffix: 'rb' },
];

function sign(amount: number): string {
  return amount < 0 ? '-' : '';
}

export function formatRupiah(amount: number): string {
  return `${sign(amount)}Rp${integerFormat.format(Math.abs(amount))}`;
}

export function formatRupiahCompact(amount: number): string {
  const abs = Math.abs(amount);
  const unit = COMPACT_UNITS.find((u) => abs >= u.size);
  if (!unit) return formatRupiah(amount);
  return `${sign(amount)}Rp${compactFormat.format(abs / unit.size)}${unit.suffix}`;
}
